import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  EventEmitter,
  Output,
  ViewChild,
  TemplateRef,
} from '@angular/core';
import routeTable from '../../../../utility/routeTable';
import { ToastrService } from 'ngx-toastr';
import {
  LotService,
  WatchListService,
  WebStorageService,
} from '../../../../services';
import { Router, ActivatedRoute } from '@angular/router';
import { FormControl, Validators } from '@angular/forms';
import { BulkBidSubmissionResult, LotPublic } from '../../../../models';
import {
  HubConnection,
  HubConnectionBuilder,
  LogLevel,
} from '@microsoft/signalr';
import { AppValidators } from '../../../../core/validators/app-validators';
import { environment } from '../../../../../environments/environment';
import {
  trigger,
  state,
  style,
  transition,
  animate,
} from '@angular/animations';
import { BidService, BulkBid } from '../../../../services/bid.service';
import constants from '../../../../utility/constants';
import { interval, Subscription } from 'rxjs';
import { AuctionTimeService } from '../../../../services/auction-time.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
export interface BidInfo {
  auctionAndLotNumber: string;
  bidCount: number;
  bidType: number;
  bulkLotReservePrice: number;
  lotStatus: number;

  currentBid: number;
  highestBid: number;
  highestBidders: Array<number> | null;
  isBiddingPaused: boolean;
  loosers: Array<number> | null;
  lotEndTimeUtc: string;
  lotId: number;
  nextRequiredBid: number;
  soldAt: number;
  soldTo: number;
  soldToName: string;
  higherBidders: any;
  extendedByMinutes: number;
  timeLeft: string;
  willSell?: boolean;
  price: number;
  recentBid: number;
  soldForBid: number;
}

@Component({
  selector: 'app-lot-card',
  templateUrl: './lot-card.component.html',
  styleUrls: ['./lot-card.component.css'],
  animations: [
    trigger('submit', [
      state(
        'noBlink',
        style({
          border: '1px #ffffff solid',
          background: '#ffffff',
        })
      ),
      state(
        'redBlink',
        style({
          border: '1px #ff1a1a solid',
          background: '#ff9999',
        })
      ),
      transition('noBlink=>redBlink', animate('250ms')),
      transition('redBlink=>noBlink', animate('1500ms')),
    ]),
  ],
})
export class LotCardComponent implements OnInit, OnDestroy {
  @Input() isUserRegistered: boolean;
  @Input('lotData') eachLotData: LotPublic;
  @Input() isItWatchList: boolean = false;
  @Input() isItActiveBidList: boolean = false;
  @Input('isListView') showListView: boolean = true;
  @Input('pageChanged') pageChange: boolean = true;
  @Input() bulkBid: boolean;
  @Output('selectedLotData') selectedLot = new EventEmitter<
    LotPublic | number
  >();
  @Output() submitBulkBid = new EventEmitter<boolean>();
  @ViewChild('quickBidModal', { static: false })
  quickBidModal: TemplateRef<any>;
  submitState: string;
  modalRef: BsModalRef;
  private _bulkBidResult: BulkBidSubmissionResult[];
  userFullName: string;
  isQuickBidOrNot: boolean;
  private subscriptions: Array<Subscription> = [];
  @Input() set bulkBidResult(value) {
    this._bulkBidResult = value;
    this.checkLotBulkBidResult(value);
  }

  get bulkBidResult() {
    return this._bulkBidResult;
  }

  hubUrl: string = environment.serverUrl + environment.hubs.bid;
  isAddedToWatchlist: boolean = false;
  isLotClosed: boolean = false;

  isConnectionClosing: boolean = false;
  soldStatuses = constants.common.soldStatus;

  loggedInUser = 0;
  showTimer: boolean = true;

  minBid: number = constants.common.bid.bidMinAmount;
  maxBid: number = constants.common.bid.bidMaxAmount;

  loader: boolean = false;
  auctionStatuses = constants.common.auctionStatus;
  errorMsg: string = null;
  isUserHighestBidder: boolean = false;
  biddingAmount: FormControl;
  private lotHubConnection: HubConnection;
  addedToWatchlist: number;
  public isLotConnected: boolean = false;

  readOnlyCatalog: boolean;

  isLowConnectionMode: boolean = false;

  lotType = constants.common.lotTypes;

  private serverTimeSubcription: Subscription;

  changeInAmount: boolean = false;

  constructor(
    private storage: WebStorageService,
    private router: Router,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private watchListService: WatchListService,
    private lotService: LotService,
    private bidService: BidService,
    private auctionTimer: AuctionTimeService,
    private modalService: BsModalService
  ) {}

  ngOnInit() {
    this.loader = true;

    let checkLotClosed = this.auctionTimer.isLotClosingBegun(
      this.eachLotData?.lotEndTimeUtc
    );

    this.submitState = 'noBlink';

    this.biddingAmount = new FormControl(null, [
      Validators.required,
      AppValidators.noWhitespace,
      AppValidators.onlyNumeric,
      Validators.min(this.minBid),
      Validators.max(this.maxBid),
    ]);

    this.isAddedToWatchlist = this.eachLotData.watchListId > 0 ? true : false;

    var loggedInData = this.storage.getBuyer()?.loggedIn;
    if (loggedInData == true) {
      this.loggedInUser = this.storage.getBuyer()?.currentUser?.user?.id;
      this.userFullName =
        this.storage.getBuyer()?.currentUser?.user?.firstName +
        ' ' +
        this.storage.getBuyer()?.currentUser?.user?.lastName;
      this.checkLotConnectionMode();
    }

    if (!this.loggedInUser) this.loader = false;

    this.readOnlyCatalog = this.eachLotData.auction.saleType.isCatalogReadOnly;

    if (!this.isLowConnectionMode) {
      if (
        this.loggedInUser > 0 &&
        this.eachLotData.loggedInUser?.isApproved &&
        this.eachLotData.auction.auctionStatus == this.auctionStatuses.live &&
        !this.readOnlyCatalog &&
        !checkLotClosed
      ) {
        this.buildConnection();
      }
      if (
        !this.eachLotData.loggedInUser ||
        !this.eachLotData.loggedInUser?.isApproved
      )
        this.loader = false;
    } else {
      this.checkHigherBidder(this.eachLotData.highestBidder);
    }

    if (
      this.loggedInUser > 0 &&
      this.eachLotData.loggedInUser?.isApproved &&
      (this.eachLotData.auction.auctionStatus == this.auctionStatuses.past ||
        checkLotClosed) &&
      !this.readOnlyCatalog
    ) {
      this.showTimer = false;
      this.isLotClosed = true;
      this.loader = false;
    }

    this.biddingAmount.valueChanges.subscribe((value: number) => {
      this.dataModelForBulkBid(value);
    });

    this.eachLotData.outbid = this.findOutbid(this.eachLotData);
  }

  private checkLotConnectionMode() {
    let storedValue = this.storage.getBuyer();
    if (storedValue)
      this.isLowConnectionMode = storedValue?.lotLowConnectionMode;
    if (this.isLowConnectionMode) this.loader = false;
  }

  refreshWholePage() {
    location.reload();
  }

  private checkAuctionDeactivated() {
    if (!this.readOnlyCatalog) {
      this.toastr.info(
        `Unfortunately ${this.eachLotData.auction.auctionCode} is no longer available for bidding and you will be notified if and when the auction becomes available for bidding again`,
        constants.common.toast.infoTitle,
        constants.common.toast.config
      );
    }
    if (this.readOnlyCatalog) {
      this.toastr.info(
        `Unfortunately ${this.eachLotData.auction.auctionCode} is deactivated and you will be notified if and when the auction becomes available again`,
        constants.common.toast.infoTitle,
        constants.common.toast.config
      );
    }
    this.router.navigateByUrl('/');
  }

  buildConnection() {
    this.lotHubConnection = new HubConnectionBuilder()
      .configureLogging(LogLevel.None)
      .withUrl(this.hubUrl)
      .withAutomaticReconnect([2000, 4000])
      .build();

    this.registerHubEvents();

    this.startConnection();
  }

  startConnection() {
    this.lotHubConnection
      .start()
      .then(() => {
        this.isConnectionClosing = false;
        this.loader = false;
        this.isLotConnected = true;
        this.isLowConnectionMode = false;
        this.getLotData();
      })
      .catch(() => {
        this.isConnectionClosing = true;
        this.loader = false;
        this.isLotConnected = false;
        this.isLowConnectionMode = true;
      });
  }

  registerHubEvents() {
    this.lotHubConnection.onreconnecting(() => {
      this.isConnectionClosing = false;
      this.loader = false;
      this.isLotConnected = false;
      this.isLowConnectionMode = true;
    });

    this.lotHubConnection.onreconnected(() => {
      this.isConnectionClosing = false;
      this.loader = false;
      this.isLotConnected = true;
      this.isLowConnectionMode = false;
      this.getLotData();
    });

    this.lotHubConnection.onclose(() => {
      this.isConnectionClosing = true;
      this.loader = false;
      this.isLowConnectionMode = true;
      if (!this.isLotConnected) this.buildConnection();
    });

    this.biddingListener();
  }

  getLotData() {
    if (!this.isLowConnectionMode) this.loader = true;
    let groupName: string =
      this.eachLotData.auction.id + '#' + this.eachLotData.id;
    this.lotHubConnection
      .invoke('AddUserToLotBidding', groupName)
      .then((response) => {
        if (response) {
          this.mapBidInfo(response);
        }
        this.loader = false;
      })
      .catch((err) => {
        this.loader = false;
      });
    this.getServerCurrentDatetime();
  }

  private dataModelForBulkBid(inputedValue: number) {
    this.eachLotData.newBid = this.biddingAmount.value;
    if (inputedValue) this.selectedLot.emit(this.eachLotData);
    else this.selectedLot.emit(this.eachLotData.id);
  }

  isTimeReached(isReached: boolean) {
    if (isReached) {
      this.getLotResults();
      this.showTimer = false;
      this.isLotClosed = true;
    }
  }

  mapBidInfo(res: BidInfo, needToShowOutBidToast = false) {
    this.changeInAmount =
      +this.eachLotData.nextRequiredBid !== +res.nextRequiredBid;
    this.eachLotData.bidCount = res.bidCount;
    this.eachLotData.currentBid = res.currentBid;
    this.eachLotData.highestBid = res.highestBid;
    this.eachLotData.highestBidder = res.highestBidders;
    this.eachLotData.nextRequiredBid = res.nextRequiredBid;
    this.eachLotData.lotEndTimeUtc = res.lotEndTimeUtc;
    this.eachLotData.soldTo = res.soldTo;
    this.eachLotData.soldAt = res.soldAt;
    this.eachLotData.extendedByMinutes = res.extendedByMinutes;
    this.eachLotData.timeLeft = res.timeLeft;
    this.eachLotData.isBiddingPaused = res.isBiddingPaused;
    this.eachLotData.lotStatus = res.lotStatus;
    this.eachLotData.willSell = res?.willSell;
    this.eachLotData.loosers = res?.loosers;
    this.eachLotData.outbid = this.findOutbid(
      this.eachLotData,
      needToShowOutBidToast
    );
    this.checkHigherBidder(res.highestBidders);
  }

  findOutbid(item, isShowMessage = false) {
    let index =
      item.loosers && item.loosers?.length > 0
        ? item.loosers?.findIndex((x) => x == this.loggedInUser)
        : -1;
    let index1 =
      item.highestBidder && item.highestBidder?.length > 0
        ? item.highestBidder?.findIndex((x) => x == this.loggedInUser)
        : -1;
    if (index > -1 && index1 == -1) {
      return true;
    } else {
      return false;
    }
  }

  biddingListener() {
    this.lotHubConnection.on('GetLotByGroupName', (data: BidInfo) => {
      if (data) this.mapBidInfo(data, true);
      this.submitState = 'redBlink';
    });
  }

  endState() {
    this.submitState = 'noBlink';
  }

  goToViewLotDetail(lotNumber: string) {
    this.router.navigate([lotNumber], {
      relativeTo: this.route,
      queryParams: { returnTo: this.router.url },
    });
  }

  goToViewLotDetailsFromWatchList(auctionCode, lotNumber) {
    this.router.navigate(['/', auctionCode, 'lots', lotNumber], {
      queryParams: { returnTo: this.router.url },
    });
  }

  getServerCurrentDatetime() {
    this.serverTimeSubcription = interval(10000).subscribe(() => {
      this.lotHubConnection.invoke('ServerCurrentDateTime').then((response) => {
        this.eachLotData.lotStartTimeUtc = response;
      });
    });
  }

  addToWatchList(lotId, lotNumber) {
    let model = {
      lotId: lotId,
      auctionId: this.eachLotData.auction.id,
    };
    const addWatchList = this.watchListService.addToWatchList(model).subscribe((res: any) => {
      this.toastr.success(
        `Lot # ${lotNumber} added to Watchlist`,
        constants.common.toast.successTitle,
        constants.common.toast.config
      );
      this.isAddedToWatchlist = true;
    });
    this.subscriptions.push(addWatchList)
  }

  removeFromWatchList(lotId, lotNumber) {
    let model = {
      lotId: lotId,
      auctionId: this.eachLotData.auction.id,
    };
    const removeWatchList = this.watchListService.removeFromWatchList(model).subscribe((res: any) => {
      this.toastr.success(
        `Lot # ${lotNumber} removed from Watchlist`,
        constants.common.toast.successTitle,
        constants.common.toast.config
      );
      this.isAddedToWatchlist = false;
    });
    this.subscriptions.push(removeWatchList)
  }

  private checkHigherBidder(highestBidders: Array<number> | null) {
    if (highestBidders != null) {
      let isHighest: number = highestBidders.find(
        (i) => i == this.eachLotData.loggedInUser?.userId
      );
      this.isUserHighestBidder = isHighest > -1 ? true : false;
    }
  }

  goToRegister(auctionCode) {
    this.router.navigate([auctionCode, routeTable.public.auctionRegister], {
      queryParams: { returnTo: this.router.url },
    });
  }

  goToAuctionTitle(auctionCode) {
    this.router.navigate([auctionCode], {
      queryParams: { returnTo: this.router.url },
    });
  }

  goToAuctionCatalog(auctionCode) {
    this.router.navigate([auctionCode, 'lots'], {
      queryParams: { returnTo: this.router.url },
    });
  }

  findLooser(): number {
    if (this.eachLotData.loosers)
      return this.eachLotData.loosers?.findIndex(
        (i) => i == +this.loggedInUser
      );
  }

  checkLotBulkBidResult(values: BulkBidSubmissionResult[]) {
    if (values && values.length) {
      let lotValue = values.find((val) => val.lotId == this.eachLotData.id);
      if (lotValue && lotValue.message) {
        this.errorMsg = lotValue.isSuccess ? '' : lotValue.message;
        this.biddingAmount.reset();
        return;
      }

      if (lotValue && lotValue.isRemoved) {
        this.biddingAmount.reset();
      }
    }
  }

  getLotDataInApi() {
    this.loader = true;
    const lotDetail = this.lotService
      .getLotDetail(
        this.eachLotData.id,
        this.eachLotData.auction.auctionCode,
        this.eachLotData.lotNumber
      )
      .subscribe(
        (res) => {
          this.eachLotData = res;
          this.checkHigherBidder(res.highestBidder);
          this.loader = false;
        },
        (err) => {
          Error(err);
          this.loader = false;
        }
      );
      this.subscriptions.push(lotDetail)
  }

  submitBidByApi(isQuickBid: boolean = false) {
    this.errorMsg = null;
    let bidAmount: number;

    if (!isQuickBid) {
      if (this.biddingAmount.invalid) return;
      bidAmount = +this.biddingAmount.value;
      if (
        this.bulkBid ||
        (this.bulkBidResult &&
          this.bulkBidResult.filter((it) => it.isRemoved == false).length > 1)
      ) {
        this.submitBulkBid.emit(true);
        return;
      } else this.submitBulkBid.emit(false);
    } else {
      bidAmount = +this.eachLotData.nextRequiredBid;
    }

    this.loader = true;

    let model: BulkBid = {
      auctionId: this.eachLotData.auction.id,
      lotAmount: [
        {
          lotId: this.eachLotData.id,
          amount: bidAmount,
        },
      ],
      userId: this.eachLotData.loggedInUser.userId,
      paddleNumber: this.eachLotData.loggedInUser.paddleNumber,
      proxyUserId: null,
    };

    this.bidService
      .submitPublicBulkBid(model)
      .toPromise()
      .then((res: any) => {
        res = res[0];
        this.loader = false;
        if (res.isSuccess) {
          this.toastr.success(
            res.message,
            constants.common.toast.successTitle,
            constants.common.toast.config
          );
          this.biddingAmount.reset();
        } else {
          this.errorMsg = res.message;
        }
        if (res.isDeactivated) {
          this.checkAuctionDeactivated();
        }
      })
      .catch((err) => {
        this.loader = false;
        this.toastr.error(
          err,
          constants.common.toast.errorTitle,
          constants.common.toast.config
        );
      });
    this.closeReviewModal();
  }

  private getLotResults() {
    this.loader = true;
    const lotResult = this.bidService.getLotResult(this.eachLotData.id).subscribe(
      (res) => {
        this.loader = false;
        this.mapBidInfo(res, true);
      },
      (err) => (this.loader = false)
    );
    this.subscriptions.push(lotResult)
  }

  onSubmit(isQuickBid: boolean = false) {
    this.changeInAmount = false;
    this.isQuickBidOrNot = isQuickBid;
    if (!this.biddingAmount.value && !this.isQuickBidOrNot) {
      return;
    } else {
      this.modalRef = this.modalService.show(this.quickBidModal, {
        class: 'custom-popup modal-dialog-centered',
        ignoreBackdropClick: true,
        keyboard: false,
      });
      this.modalRef.onHidden.subscribe(() => {
        this.changeInAmount = false;
      });
    }
  }

  closeReviewModal() {
    this.changeInAmount = false;
    this.modalRef.hide();
  }

  ngOnDestroy() {
    if (this.serverTimeSubcription) this.serverTimeSubcription.unsubscribe();
    if (this.pageChange && this.isLotConnected) {
      this.lotHubConnection.stop();
    }
    this.subscriptions.forEach((sub: Subscription) => {
      sub.unsubscribe();
    });
  }
}
